import _ from 'lodash'
import superagent from 'superagent'

import { attachSessionStateMirrorListener } from '@/services/session/session-state-mirror-listener'

/**
 * FIXME:
 * client/src/services/api/clientで同名のconstがexportされているため統合を検討したい
 * なお、シグネチャが異なるという罠があることに注意
 */
export class ApiClient {
  static get(url: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .get(url)
      .withCredentials()
      .set({ Accept: 'application/json' }))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  static post(url: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .post(url)
      .withCredentials()
      .set({
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      })
      .type('form'))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  static postMultipart(url: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .post(url)
      .withCredentials()
      .set({
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      }))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  static postPlain(endpoint: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .post(endpoint)
      .withCredentials()
      .set('Accept', 'application/json')
      .set('Content-Type', 'text/plain'))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  /**
   * "Content-Type: application/json" でpostする
   */
  static postJson(url: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .post(url)
      .withCredentials()
      .set({
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
      }))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  static put(url: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .put(url)
      .withCredentials()
      .set({
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      })
      .type('form'))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  static delete(url: string): superagent.SuperAgentRequest {
    const request = attachSessionStateMirrorListener(superagent
      .delete(url)
      .withCredentials()
      .set({ Accept: 'application/json' }))

    if (!this.shouldBasicAuth()) {
      return request
    }

    const { id, password } = this.getBasichAuthInfo()

    return request.auth(id, password)
  }

  private static shouldBasicAuth(): boolean {
    const id = process.env.BASIC_AUTH_ID
    const password =  process.env.BASIC_AUTH_PASSWORD

    return !_.isEmpty(id) && !_.isEmpty(password)
  }

  private static getBasichAuthInfo(): { id: string, password: string} {
    return {
      id: process.env.BASIC_AUTH_ID || '',
      password: process.env.BASIC_AUTH_PASSWORD || '',
    }
  }
}
